// Delivery time estimator based on Indian pincode.
//
// Tiers:
//   • Metro      : 5–7 working days
//   • Tier-2/3   : 8–10 working days
//   • Remote     : 10–12 working days
//
// Rules:
//   - Metro pincode prefixes cover Mumbai, Delhi/NCR, Bengaluru, Chennai,
//     Kolkata, Hyderabad, Pune and Ahmedabad.
//   - Remote prefixes cover Jammu & Kashmir / Ladakh, the eight North-East
//     states and Andaman & Nicobar / Lakshadweep islands.
//   - Anything else falls back to Tier-2/3.

const METRO_PREFIXES = new Set([
  // Delhi NCR
  '110', '111', '112', '113', '114',
  '201', '110', '121', '122', '124', '125', '127',
  // Mumbai (incl. Thane, Navi Mumbai)
  '400', '401', '410', '421',
  // Bengaluru
  '560', '561', '562',
  // Chennai
  '600', '601', '602', '603',
  // Kolkata
  '700', '711', '712',
  // Hyderabad / Secunderabad
  '500', '501', '502',
  // Pune
  '411', '412',
  // Ahmedabad / Gandhinagar
  '380', '382',
]);

const REMOTE_PREFIXES = new Set([
  // J&K + Ladakh
  '180', '181', '182', '184', '185', '190', '191', '192', '193', '194',
  // North-East
  '781', '782', '783', '784', '785', '786', '787', '788', '789',
  '790', '791', '792', '793', '794', '795', '796', '797', '798', '799',
  // Andaman & Nicobar
  '744',
  // Lakshadweep
  '682',
]);

export const DELIVERY_TIERS = {
  metro: { label: 'Metro city', minDays: 5, maxDays: 7 },
  tier2: { label: 'Tier-2 / Tier-3 city', minDays: 8, maxDays: 10 },
  remote: { label: 'Remote pincode', minDays: 10, maxDays: 12 },
};

export const getDeliveryTier = (pincode) => {
  if (!pincode || String(pincode).length < 3) return DELIVERY_TIERS.metro;
  const prefix = String(pincode).slice(0, 3);
  if (REMOTE_PREFIXES.has(prefix)) return DELIVERY_TIERS.remote;
  if (METRO_PREFIXES.has(prefix)) return DELIVERY_TIERS.metro;
  return DELIVERY_TIERS.tier2;
};

// Add `days` working days (skipping Sundays) to today.
export const addWorkingDays = (days) => {
  const d = new Date();
  let added = 0;
  while (added < days) {
    d.setDate(d.getDate() + 1);
    if (d.getDay() !== 0) added += 1; // skip Sunday
  }
  return d;
};

export const getDeliveryWindow = (pincode) => {
  const tier = getDeliveryTier(pincode);
  return {
    tier,
    minDate: addWorkingDays(tier.minDays),
    maxDate: addWorkingDays(tier.maxDays),
  };
};

export const formatShortDate = (d) =>
  d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });

export const toIsoDate = (d) => d.toISOString().slice(0, 10);
